import { useState } from 'react';
import ReactDOM from 'react-dom';
import classNames from 'classnames';

import questionIcon from '../../assets/img/info-circle.png';
import { useIsMobile } from '../../hooks';
import { ClickableDiv, ClickableImage, MobileDrawer } from '..';

import styles from './Questionmark.module.scss';

type Props = {
  text: string;
  isSvg?: boolean;
  title: string;
  tooltipBelow?: boolean;
  tooltipUp?: boolean;
  tooltipTopPosition?: number;
  boldText?: string;
};

const Questionmark = (props: Props) => {
  const { text, isSvg, title, tooltipBelow, tooltipUp, tooltipTopPosition, boldText } = props;
  const { isMobile } = useIsMobile();

  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  const handleOpenDrawer = () => setIsDrawerOpen(true);
  const handleCloseDrawer = () => setIsDrawerOpen(false);

  return (
    <>
      <ClickableDiv
        className={isSvg ? styles.svgContainer : styles.container}
        onClick={isMobile ? handleOpenDrawer : undefined}
      >
        <ClickableImage
          className={isSvg ? styles.svg : ''}
          src={questionIcon}
          alt="questionmark"
        />
        {!isMobile && (
          <span
            style={{ top: tooltipTopPosition }}
            className={classNames(
              { [styles.tooltip]: !tooltipBelow && !tooltipUp },
              { [styles.tooltipBelow]: tooltipBelow && !tooltipUp },
              { [styles.tooltipUp]: tooltipUp && !tooltipBelow },
            )}
          >
            {text}
            <span className={styles.boldText}>{boldText}</span>
          </span>
        )}
      </ClickableDiv>

      {isMobile
        && isDrawerOpen
        && ReactDOM.createPortal(
          <MobileDrawer isOpen={isDrawerOpen} title={title} onClose={handleCloseDrawer}>
            <span className={styles.drawerText}>{text}</span>
            <span className={styles.boldText}>{boldText}</span>
          </MobileDrawer>,
          document.body,
        )}
    </>
  );
};

export default Questionmark;
